<template>

  <FatturazioneExtra />

</template>

<script>
import FatturazioneExtra from '../components/fatturazione/FatturazioneExtra.vue'

export default {
  pageName: 'FatturazioneExtra',
  components: {
    FatturazioneExtra

  },
  data() {
    return {

    }
  },

  created(){
    
  },

  mounted(){
    this.$eventBus.emit('page-change', {
      target: this,
      currentRoute: this.$router.currentRoute.value
    })
  },

  methods: {
    
  },
}
</script>
